export type NewRoleData = {
  name: string;
  description: string;
  menuRouteNames: string[];
}

export type UserRoleItemType = {
  '@id': string;
  '@type': string;
  id: number;
  name: string;
}

export type UserRoleDataType = {
  '@id': string;
  '@type': string;
  member: UserRoleItemType[];
  search: any;
  totalItems: number;
  view: any;
}

export type RoleDetailType = {
  "@context": string;
  "@id": string;
  "@type": string;
  description: string;
  id: number;
  menuRouteNames: string[];
  name: string;
  nameCrypt: string;
}

export type UserRolePageState = {
  page: number;
  pagination: boolean;
  itemsPerPage: number;
  name?: string | null;
  q?: string | null;
  'order'?: {dataKey: string; order?: "asc" | "desc"};
}

export type UserRoleListStateType = {
  pageState: UserRolePageState,
  setPageState: (state: UserRolePageState) => void;
  resetPageState: () => void;
}

export const initialUserRolePageState: UserRolePageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  'order': {dataKey: 'id', order: 'desc'},
}